const easing = {
  inOutStrong: `cubic-bezier(0.5, 0.000, 0.300, 1.000)`,
  outStrong: `cubic-bezier(.33,1,.68,1)`,
}

export default easing
